import collectionReducer from '../collectionReducer';

export default collectionReducer({
    apiCollectionName: 'clients',
    collectionActionName: 'CLIENTS',
    itemActionName: 'CLIENT',
});
